import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import qs from 'qs';
import baseUrl from  '../../../utils/baseUrl';

import { dispatchError, dispatchMsg } from '../../../actions/errors';

import Splitter from '../../account/block/splitter';
import Countdown from '../../countdown/countdown';

import Spinner from '../../svg/spinner';

import JuryEntry from './juryEntry';
import JuryVoteFOTX from './juryVoteFOTX';

import { AccountJuryMediaTitle } from './other';

export default class AccountJuryFOTX extends Component {

	static propTypes = {
		api: PropTypes.string.isRequired,
		cases: PropTypes.array.isRequired,
	};

	static defaultProps = {
		nextDate: new Date().getTime() / 1000,
		isVotingOpen: false,
		currentVotes: [],
		cases: [],
	};

	constructor(props) {
		super();

		this.state = {
			cases: props.cases,
			selected: this.getSelected(props.currentVotes),
			comments: {},
			submitting: false,
		};
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.cases !== nextProps.cases) {
			this.setState({
				...this.state,
				cases: nextProps.cases,
				selected: this.getSelected(nextProps.currentVotes),
			});
		}
	}

	render() {
		let VOTE_PATH = this.props.api + '/vote';

		return (
			<div>
				<Splitter />

				<div className='account-block-content account-jury__voting-ends'>
					{this.props.isVotingOpen ? 'Voting ends in:' : 'Voting starts in:'}
				</div>

				<div className='account-block-content'>
					<Countdown timeLeft={(this.props.nextDate) - (new Date().getTime() / 1000)} spans='span14' />
					<div className='cf'></div>
				</div>

				<Splitter />

				{(this.props.browser.window.width < 1200) && (
					<AccountJuryMediaTitle browser={this.props.browser} caseCount={this.props.cases.length} />
				)}

				{this.state.cases.map((item, i) =>
					<JuryEntry
						key={item.id}
						item={item}
						selected={this.state.selected}
						browser={this.props.browser}
						dispatch={this.props.dispatch}
						component={JuryVoteFOTX}
						hideAfterSubmit={false}
						path={VOTE_PATH}
						onChangeVote={this.onChangeVote.bind(this)}
						onSubmit={this.onSubmit.bind(this)}
						data={this.getCurrentVote(item.id, this.props.currentVotes)}
						waiting={this.state.submitting}
					/>
				)}
			</div>
		);
	}

	getCurrentVote(id, currentVotes) {
		for (let i = 0; i < currentVotes.length; i++) {
			if (currentVotes[i].caseId === id) {
				return currentVotes[i];
			}
		}

		return false;
	}

	getSelected(currentVotes) {
		for (let i = 0; i < currentVotes.length; i++) {
			if (currentVotes[i].vote) {
				return currentVotes[i].caseId;
			}
		}

		return false;
	}

	onChangeVote(val) {
		//console.log(val);

		this.setState({
			...this.state,
			selected: val.value ? val.id : false,
		});

	}

	onSubmit(res) {
		let newState = { ...this.state, submitting: (res.id ? res.id : false) };
		if (res.id && typeof res.comment === 'string') {
			newState.comments[res.id] = res.comment;
		}

		// post vote
		if (newState.selected) {
			axios.post(this.props.api + '/vote', qs.stringify({
				comments: newState.comments,
				vote: newState.selected,
			}))
			.then((res) => {
				this.endSubmit(this.state);
				this.props.dispatch(dispatchMsg(res.data));
			})
			.catch((res) => {
				this.endSubmit(this.state);
				this.props.dispatch(dispatchError(res.data));
			});

			this.setState(newState);
		}
	}

	endSubmit(state) {
		this.setState({
			...state,
			submitting: false,
		});
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/jury/fotx.js
 **/